import { useEffect, useMemo, useRef } from 'react';
import { throttle } from 'lodash';
import type { ArdoqId } from '@ardoq/api-types';
import { componentMatrixCommands } from './commands';

const MOUSE_MOVE_EVENT_THROTTLE = 50;

type HoveredItemHandlers = {
  onMouseEnter: VoidFunction;
  onMouseLeave: VoidFunction;
};

export const useHoveredItemHandlers = (
  componentId: ArdoqId
): HoveredItemHandlers => {
  const isPointerInsideRef = useRef(false);
  const throttledSetHoveredItem = useMemo(
    () =>
      throttle(() => {
        if (!isPointerInsideRef.current) {
          return;
        }
        componentMatrixCommands.setHoveredItemState(componentId);
      }, MOUSE_MOVE_EVENT_THROTTLE),
    [componentId]
  );
  useEffect(
    () => () => throttledSetHoveredItem.cancel(),
    [throttledSetHoveredItem]
  );

  return {
    onMouseEnter: () => {
      isPointerInsideRef.current = true;
      throttledSetHoveredItem();
    },
    onMouseLeave: () => {
      isPointerInsideRef.current = false;
      componentMatrixCommands.setHoveredItemState(null);
    },
  };
};
